import { Pressable, TextInput, View } from 'react-native'

import { styled } from '~/core/styled'

export const Container = styled(View, theme => {
  return {
    base: {
      minWidth: 360,
      gap: theme.spacingStackHalfpulse,

      position: 'relative',
    },
    variants: {
      full: {
        true: {
          width: '100%',
        },
      },
    },
  }
})

export const HiddenInput = styled(TextInput, {
  base: {
    width: 0,
    height: 0,

    position: 'absolute',
  },
})

export const ClearButtonTouchableArea = styled(Pressable, {
  base: {
    position: 'absolute',
  },
})
